import React, { createContext, useContext, useState } from 'react';

const CookieContext = createContext();

export const useCookieModal = () => useContext(CookieContext);

export const CookieProvider = ({ children }) => {
    const [isCookieModalOpen, setIsCookieModalOpen] = useState(false);

    const openCookieModal = () => setIsCookieModalOpen(true);
    const closeCookieModal = () => setIsCookieModalOpen(false);

    return (
        <CookieContext.Provider value={{ isCookieModalOpen, openCookieModal, closeCookieModal }}>
            {children}
        </CookieContext.Provider>
    );
};
